// extracted by mini-css-extract-plugin
export default {"select":"SelectFunds_select__eeFTi"};